export default {
  loading: false,
  listLoading: false,
  records: [],
  total: 0,
  FilteredCount: 0,
  createLoading: false,
  record: {},
  refferdUsers : [],
  refferdUsersLoading: false,
  subscriptionListLoading: false,
  subscriptionRecords: [],
  subscriptionTotal: 0,
  subscriptionFilteredCount: 0,
  subscriptionUserDetail: null
}
